<div class="spinner-overlay" [ngClass]="opaque ? 'opaque-background' : ''"></div>
<mat-spinner class="center"></mat-spinner>

